export default __webpack_public_path__ + "assets/images/289bbcbd05a50fae437a66f14d3eb4c4.svg";